import React, { Component } from 'react';
import * as bActs from '../actions/blog-actions';
import * as wActs from '../actions/website-actions';
import {Link} from 'react-router-dom'
import connect from "react-redux/es/connect/connect";

class SmallBlogList extends Component {

  componentDidMount() {
    let loc = typeof window === "undefined" ? "" : window.location.href;
    this.props.dispatch(bActs.GetBlogPosts(loc));
  }

  render() {
    let loc = typeof window === "undefined" ? "" : window.location.href;
    let blogList = () => {
      return (
        <div></div>
      );
    };

    if(this.props.Loaded && this.props.Code === 200) {
      blogList = () => {
        //console.log(this.props);
        return this.props.Posts.map((v,i) => {
          if(i>5) {return null}
          const bLink = wActs.getCultPath(this.props.WebPage,this.props.WebPage.Settings.BlogPath + "/" + v.Slug);
          return (
            <Link key={"blog-link-" + i} to={bLink} className="sidebar-post">
              <span className="img-thumb">
                  <img src={v.Image.Url} alt={v.Image.Title} style={{width: "40px"}}/>
              </span>
              <span className="post-title">
                <h3>{v.Title}</h3>
              </span>
            </Link>
          );
        });
      }
    }

    return blogList()
  }
}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website,
    BlogList: state.Blog.BlogList,
    Posts: state.Blog.BlogList.Result.Result,
    Loaded: state.Blog.BlogList.Loaded,
    Code: state.Blog.BlogList.Result.Code,
  };
}

export default connect(mapStateToProps)(SmallBlogList);
